import { Icons, LabelChipV2 } from '@cast/design-system';

type TrendDirection = 'up' | 'down';

type Props = {
  direction?: TrendDirection;
  label: string;
};

export const BannerMetricTrendChip = ({ direction = 'up', label }: Props) => {
  const Icon = direction === 'up' ? Icons.ArrowUpRight : Icons.ArrowDownRight;

  return (
    <LabelChipV2
      label={label}
      color="green"
      size="s"
      slots={{ startIcon: <Icon /> }}
    />
  );
};
